import React, { useState, useRef } from "react";
import { Image as ImageIcon, X, Upload, Loader2 } from "lucide-react";

const Details = ({ formData, handleInputChange }) => {
  const [imageError, setImageError] = useState("");
  const fileInputRef = useRef(null);

  const handleImageSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validar tipo de archivo
    if (!file.type.startsWith('image/')) {
      setImageError("Please upload an image file");
      return;
    }

    // Validar tamaño (5MB max)
    if (file.size > 5 * 1024 * 1024) {
      setImageError("Image size should be less than 5MB");
      return;
    }

    setImageError("");

    try {
      // Crear vista previa y enviar archivo al hook principal
      handleInputChange({
        target: {
          name: 'coverImage',
          value: {
            file: file,
            preview: URL.createObjectURL(file)
          }
        }
      });
    } catch (error) {
      console.error("Error handling image:", error);
      setImageError("Failed to process image. Please try again.");
    }
  };

  const handleRemoveImage = () => {
    handleInputChange({
      target: {
        name: 'coverImage',
        value: {
          file: null,
          preview: ''
        }
      }
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div className="space-y-4">
      {/* Description */}
      <div className="bg-white p-4 rounded-xl shadow-sm">
        <textarea
          name="description"
          placeholder="Add a description..."
          value={formData.description}
          onChange={handleInputChange}
          rows="4"
          className="w-full focus:outline-none resize-none"
          maxLength={500}
        />
        <div className="text-right text-xs text-gray-400 mt-2">
          {formData.description.length}/500
        </div>
      </div>

      {/* Image Upload */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        {formData.coverImage ? (
          <div className="relative">
            <img
              src={formData.coverImage}
              alt="Cover preview"
              className="w-full h-48 object-cover"
            />
            <button
              type="button"
              onClick={handleRemoveImage}
              className="absolute top-2 right-2 p-1 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              <X className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        ) : (
          <div className="p-4">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageSelect}
              className="hidden"
              ref={fileInputRef}
              id="cover-image-input"
            />
            <label
              htmlFor="cover-image-input"
              className="w-full min-h-[120px] border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center gap-2 cursor-pointer hover:border-orange-500 transition-colors"
            >
              <Upload className="w-6 h-6 text-gray-400" />
              <span className="text-sm text-gray-500">Click to upload cover image</span>
              <span className="text-xs text-gray-400">PNG, JPG (max. 5MB)</span>
            </label>
          </div>
        )}
        
        {imageError && (
          <div className="px-4 py-2 text-sm text-red-600 bg-red-50">
            {imageError}
          </div>
        )}
      </div>
    </div>
  );
};

export default Details;